<template>
  <div>
    <navBar
      @logout="logout"
      :organizationData="organizationData"
      @organizationFinder="organizationFinder"
      :organizationName="organizationName"
      @addOrganizationPage="addOrganizationPage"
      @deleteOrganization="deleteOrganization"

    ></navBar>
    <section id="columnSection" style="margin-top:100px">

      <!-- <button v-on:click="addOrganizationPage()">Add Organization</button> -->
        
      <div v-if="organizationName">
        

        <!-- <button v-on:click="deleteOrganization()">Delete This Organization</button> -->
        

        <label>Invite Friend :</label>
        <input type="text" v-model="emailTeman" />
        <button v-on:click="addFriend"><img src="https://cdn0.iconfinder.com/data/icons/social-media-glyph-1/64/Facebook_Social_Media_User_Interface-38-512.png" style="width:25px;height:25px"/></button>
        <br />
        <br />
        <button v-on:click="addColumnPage()" class="button-addColumn">Add Column</button>
      </div>

      <div class="column">
        <div class="cardColumn" style="min-width: 13rem;" v-for="(col,i) in dataColumn" :key="i">
          <button v-on:click="deleteColumn(columnId[i])" class="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="card-header">{{col}}</div>
          <ul class="list-group list-group-flush">
            <TodoList :task="columns[i].tasks" @deleteTask="deleteTask" @createEditPage="createEditPage"></TodoList>
            <!-- <li v-for="task in dataTask[i]" class="list-group-item" :key="task.id">
              <div class="card">
                <div class="card-body p-1">
                  <input style="font-size: smaller" v-model="task.title" />
                  <textarea
                    class="cardTextArea"
                    style="font-size: smaller;"
                    v-model="task.description"
                  ></textarea>
                  <div class="cardFooter">
                    <div class="cardFooterKanan">
                      <p class="p-1" style="font-size: smaller;">{{task.user.name}}</p>
                      <p class="p-1" style="font-size: smaller;">{{task.user.createdAt.slice(0,10)}}</p>
                    </div>
                    <div class="cardFooterKiri">
                      <button v-on:click="createEditPage(task.id)" class="button-edit">E</button>
                      <button v-on:click="deleteTask(task.id)" class="button-delete">D</button>
                    </div>
                  </div>
                </div>
              </div>
            </li> -->
          </ul>
          <div class="addTaskButton">
          <button v-on:click="createTaskPage(columnId[i])" class="plus-button plus-button--small">+</button>
          <p>Add Task</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import navBar from "./NavBar";
import TodoList from "../components/ToDoList"
export default {
  name: `listColumn`,
  components: {
    navBar,
    TodoList
  },
  props: ["columns", "organizationData", "organizationName"],
  data() {
    return {
      emailTeman: ""
      //  dataColumn: [],
      //   dataTask: [],
      //   columnId: [],
    };
  },
  methods: {
    deleteColumn(params) {
      let payload = {
        id: params
      };
      this.$emit("deleteColumn", payload);
      // console.log(params)
    },
    addColumnPage() {
      this.$emit("addColumnPage");
    },
    createTaskPage(params) {
      let payload = {
        id: params
      };
      this.$emit("createTaskPage", payload);
      //   console.log(params);
    },
    createEditPage(payload) {
      this.$emit("createEditPage", payload);
      // console.log(params)
    },
    logout() {
      this.$emit("logout");
    },
    organizationFinder(params) {
      this.$emit("organizationFinder", params);
      //   this.pisahinColumn();
    },
    deleteTask(payload) {
      // let payload = {
      //   id: params
      // };
      this.$emit("deleteTask", payload);
      // console.log(params,`delete params`);
    },
    addOrganizationPage() {
      this.$emit("addOrganizationPage");
    },
    deleteOrganization() {
      this.$emit("deleteOrganization");
    },
    addFriend() {
      let payload = {
        email: this.emailTeman
      };
      this.$emit("addFriend", payload);
      this.emailTeman = "";
    }
  },
  created: function() {},
  computed: {
    dataColumn() {
      let result = [];
      for (let i = 0; i < this.columns.length; i++) {
        result.push(this.columns[i].title);
      }
      return result;
    },
    dataTask() {
      let result = [];
      for (let i = 0; i < this.columns.length; i++) {
        result.push(this.columns[i].tasks);
      }
      return result;
    },
    columnId() {
      let result = [];
      for (let i = 0; i < this.columns.length; i++) {
        result.push(this.columns[i].id);
      }
      return result;
    }
  }
};
</script>

<style>
</style>